import template from './contact-chronology-form.pug';

export const ContactChronologyFormComponent = {
  template,
  bindings: {
    item: '<',
    onDestroy: '&?'
  },
  controller: class ContactChronologyFormComponent {
    constructor(Chronology, $async, $log) {
      'ngInject';

      this.Chronology = Chronology;

      this.$log = $log;
      this.destroyRecord = $async(this.destroyRecord.bind(this));
    }

    $onInit() {}

    async destroyRecord() {
      try {
        await this.Chronology.destroyChild(this.item.id);
        this.onDestroy({ $event: { chronologyItem: this.item } });
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
